Object.defineProperty(Array.prototype, "getPreview", {
  value: function () {
    if (this.length > 0) {
      const firstItem = this[0];
      if (firstItem instanceof Blob || firstItem instanceof File) {
        const blobUrl = URL.createObjectURL(firstItem);
        return blobUrl;
      }
    }
    return null; // Return null if the array is empty or the first item is not a Blob or File
  },
  enumerable: false,
});

// Whether Back stays inside the app. vue-router records the previous in-app
// location in history.state.back; history.length also counts the sites this
// tab visited before, so an opened link went Back out of the app.
export function hasHistory() {
  return window.history.state?.back != null;
}

export function getStatusColor(status) {
  switch (status) {
    case "in_progress":
      return "blue";
    case "completed":
      return "green";
    case "on_hold":
      return "orange";
    case "canceled":
      return "red";
    case "edit_request":
      return "purple";
    case "not_started":
      return "grey";
  }
}

export function getStatusText(status) {
  switch (status) {
    case "not_started":
      return "Niet gestart";
    case "in_progress":
      return "In bewerking";
    case "completed":
      return "Voltooid";
    case "on_hold":
      return "In afwachting";
    case "canceled":
      return "Geannuleerd";
    case "edit_request":
      return "Wijzigingsverzoek";
    default:
      return "";
  }
}

export function convertUnixToDate(unix) {
  if (unix === null || unix === undefined || unix === "") return "";

  const n = Number(unix);
  if (!Number.isFinite(n)) return "";

  const ms = n < 1e12 ? n * 1000 : n; // supports seconds or milliseconds
  const d = new Date(ms);

  if (Number.isNaN(d.getTime())) return "";

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = String(d.getFullYear());

  return `${dd}-${mm}-${yyyy}`;
}

export function convertUnixToTime(unix) {
  if (unix === null || unix === undefined || unix === "") return "";

  const n = Number(unix);
  if (!Number.isFinite(n)) return "";

  const ms = n < 1e12 ? n * 1000 : n; // supports seconds or milliseconds
  const d = new Date(ms);

  if (Number.isNaN(d.getTime())) return "";

  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");

  return `${hh}:${mm}`;
}

// Long, locale-aware date+time for the edit-request card footer, e.g.
// "15 juli '26, 09:12" (nl) / "15 July '26, 09:12" (en). Accepts unix
// seconds or milliseconds, like convertUnixToDate/Time.
export function convertUnixToLongDateTime(unix, locale = "nl") {
  if (unix === null || unix === undefined || unix === "") return "";

  const n = Number(unix);
  if (!Number.isFinite(n)) return "";

  const ms = n < 1e12 ? n * 1000 : n;
  const d = new Date(ms);

  if (Number.isNaN(d.getTime())) return "";

  const month = new Intl.DateTimeFormat(locale === "en" ? "en-GB" : "nl-NL", {
    month: "long",
  }).format(d);
  const day = d.getDate();
  const year = String(d.getFullYear()).slice(-2);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");

  return `${day} ${month} '${year}, ${hh}:${mm}`;
}
